import { render, staticRenderFns } from "./OrganizProctorList.vue?vue&type=template&id=082f1ee8&scoped=true&"
import script from "./OrganizProctorList.vue?vue&type=script&scoped=true&lang=js&"
export * from "./OrganizProctorList.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./OrganizProctorList.vue?vue&type=style&index=0&id=082f1ee8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082f1ee8",
  null
  
)

export default component.exports